export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "excelbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "excelbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
